import { observable, action, flow, computed, set, toJS } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Serv from './CertificatesServ';

class CertificatesMod {
  // 证件列表使用id对象存储
  @observable certificateMap = {};

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 查询会员证件列表
   */
  queryCertificateList = flow(function* () {
    try {
      const { data } = yield Serv.queryCertificateList();
      if (Array.isArray(data)) {
        this.certificateMap = {};
        data.forEach((_item) => {
          set(this.certificateMap, { [+_item.certificateType]: _item });
        });
      }
    } catch (error) {}
  });

  /**
   * 更新会员证件信息
   */
  updateCert = flow(function* (params) {
    try {
      yield Serv.updateCert([params]);
      Toast.success('提交成功！', 1, () => {
        window.app.router.goBack();
      });

      const typeMap = {
        1: '身份证',
        2: '护照',
        3: '港澳台证',
        4: '其他证件',
        5: '户口本',
        6: '学历证书',
        7: '关系证明',
        8: '标准一寸照',
        9: '结婚照',
        10: '税务委托书',
        11: '营业执照',
        12: '表彰照',
        13: '其他',
        14: '合同协议'
      };

      // 神策数据发送
      let modifyType = typeMap[+params.certificateType];
      window.sensors.track('userInfoModify', { modifyType });
    } catch (error) {}
  });

  // 提交开票函审核
  submitInvoicing = flow(function* (params) {
    try {
      const { resultCode, resultMsg, data } = yield Serv.submitInvoicing(params);
      if (resultCode == 0) {
        Toast.success('提交成功！', 1, () => {
          window.app.router.goBack();
        });
      } else {
        Toast.fail('提交失败!');
      }
    } catch (err) {
      Toast.fail('系统错误');
      console.log(err);
    }
  });

  /**
   * inputItemList 数据值
   */
  @computed
  get inputValuesMap() {
    toJS(this.certificateMap);
    let mapping = {};
    Object.values(this.certificateMap).forEach((_item) => {
      let type = [1, 2, 3, 4].includes(+_item.certificateType) ? 1 : _item.certificateType;
      mapping[type] =
        _item.auditStatus == 1 ? '审核中' : _item.auditStatus == 2 ? '已上传' : '审核不通过';
    });
    return mapping;
  }
}
const certificatesMod = new CertificatesMod();
export default certificatesMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Certificates/CertificatesMod.js